import { Component, OnInit, Output, EventEmitter, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { BotonTipo } from '../../../../components/boton/boton';
import { CrearContactoDialog } from './crear-contacto-dialog/crear-contacto-dialog.component';
import { AlertaContactoDialog } from '../alerta-contacto/alerta-contacto/alerta-contacto-dialog.component';
import { EliminarContactoDialog } from '../eliminar-contacto/eliminar-contacto-dialog/eliminar-contacto-dialog.component';
import { ContactoService } from '../../../../providers/contacto.service';
import { Contacto } from '../../../../interfaces/contacto';

@Component({
  selector: 'app-crear-contacto',
  templateUrl: './crear-contacto.component.html',
  styleUrls: ['./crear-contacto.component.scss']
})
export class CrearContactoComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();
  @Input() entidadRazonSocial: string; // traigo la razon social de la entidad.

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dialogAlerta: MatDialogRef<AlertaContactoDialog>,
    public dialogCrear: MatDialogRef<CrearContactoDialog>,
    public dialogEliminar: MatDialogRef<EliminarContactoDialog>,
    private contactoSv: ContactoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log('DATA Component', data);
  }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }

  openDialog(): void {
    //TEST
    // let dialogEliminar = this.dialog.open(EliminarContactoDialog, {
    //   disableClose: true
    // });
    // console.log('Paso', this.entidadRazonSocial);

    let dialogCrear = this.dialog.open(CrearContactoDialog, {
      disableClose: true,
      data: {
        entidadRazonSocial: this.entidadRazonSocial
      },
    });

    dialogCrear.afterClosed().subscribe(contactoCreado => {
      if (contactoCreado) {
        this.onCerrado.emit({ contacto: contactoCreado });
        // console.log('On Cerrado', contactoCreado);

      } else {
        this.onCerrado.emit({ contacto: null });
      }
    });

    dialogCrear.afterClosed().subscribe(contactoCreado => {
      // console.log('Contacto Creado', contactoCreado);
      contactoCreado.entidad = {
        IdEntidad: this.data.IdEntidad
      };
      // console.log('contactoCreado.entidad', contactoCreado.entidad.IdEntidad);
    });
  }
}
